module.exports = __webpack_public_path__ + "img/api_utilities.fef12ff4.svg";